import Logo from "../resources/logo.svg";

function Prinzenpaare() {

  const pps = [
    { Prinzenpaar: "2025_2026", namen: " Corinna I & Niklas I", jahr: 2026 },
    { Prinzenpaar: "2025_2026_kpp", namen: " Laura II & Oliver I", jahr: 2026 },
    { Prinzenpaar: "2024_2025", namen: " Sophia I & Markus I", jahr: 2025 },
    { Prinzenpaar: "2024_2025_kpp", namen: " Elisa I & Bastian I", jahr: 2025 },
    { Prinzenpaar: "2023_2024", namen: " Carolin I & Nico I", jahr: 2024 },
    { Prinzenpaar: "2023_2024_kpp", namen: " Marlene I & Jakob I", jahr: 2024 },
    { Prinzenpaar: "2022_2023", namen: " Katja I & Gabriel I", jahr: 2023 },
    { Prinzenpaar: "2022_2023_kpp", namen: " Emilia I & Leopold I", jahr: 2023 },
    { Prinzenpaar: "2019_2020", namen: " Sabrina I & Marco I", jahr: 2020 },
    { Prinzenpaar: "2019_2020_kpp", namen: " Lea I & Niklas I", jahr: 2020 },
    { Prinzenpaar: "2018_2019", namen: " Marlene I & Sebastian II", jahr: 2019 },
    { Prinzenpaar: "2018_2019_kpp", namen: " Nina I & Joseph I", jahr: 2019 },
    { Prinzenpaar: "2017_2018", namen: " Stefanie I & Michael III", jahr: 2018 },
    { Prinzenpaar: "2017_2018_kpp", namen: " Fiona I & Johannes II", jahr: 2018 },
    { Prinzenpaar: "2016_2017", namen: " Christina I & Dominik I", jahr: 2017 },
    { Prinzenpaar: "2016_2017_kpp", namen: " Franziska I & Andreas I", jahr: 2017 },
    { Prinzenpaar: "2015_2016", namen: " Theresa II & Johann I", jahr: 2016 },
    { Prinzenpaar: "2015_2016_kpp", namen: " Tina I & Tobias II", jahr: 2016 },
    { Prinzenpaar: "2014_2015", namen: " Jennifer I & Matthias I", jahr: 2015 },
    { Prinzenpaar: "2014_2015_kpp", namen: " Lilly I & Tobias I", jahr: 2015 },
    { Prinzenpaar: "2013_2014", namen: " Kerstin I & Stephan II", jahr: 2014 },
    { Prinzenpaar: "2013_2014_kpp", namen: " Alicia I & Daniel II", jahr: 2014 },
    { Prinzenpaar: "2012_2013", namen: " Teresa I & Sebastian I", jahr: 2013 },
    { Prinzenpaar: "2012_2013_kpp", namen: " Annika II & Bernhard I", jahr: 2013 },
    { Prinzenpaar: "2011_2012", namen: " Pia I & Manuel II", jahr: 2012 },
    { Prinzenpaar: "2011_2012_kpp", namen: " Maria I & Matthias I", jahr: 2012 },
    { Prinzenpaar: "2010_2011", namen: " Nadine I & Florian II", jahr: 2011 },
    { Prinzenpaar: "2010_2011_kpp", namen: " Beatrice I & Manuel II", jahr: 2011 },
    { Prinzenpaar: "2009_2010", namen: " Ramona I & Thomas II", jahr: 2010 },
    { Prinzenpaar: "2009_2010_kpp", namen: " Annika I & Thomas I", jahr: 2010 },
    { Prinzenpaar: "2008_2009", namen: " Laura I & Manuel I", jahr: 2009 },
    { Prinzenpaar: "2008_2009_kpp", namen: " Carolin I & Johannes I", jahr: 2009 },
    { Prinzenpaar: "2007_2008", namen: " Tanja I & Tobias II", jahr: 2008 },
    { Prinzenpaar: "2007_2008_kpp", namen: " Leonie I & Jan I", jahr: 2008 },
    { Prinzenpaar: "2006_2007", namen: " Daniela II & Joseph II", jahr: 2007 },
    { Prinzenpaar: "2006_2007_kpp", namen: " Katja I & Lorenzo I", jahr: 2007 },
    { Prinzenpaar: "2005_2006", namen: " Martina II & Martin II", jahr: 2006 },
    { Prinzenpaar: "2005_2006_kpp", namen: " Miriam I & Daniel I", jahr: 2006 },
    { Prinzenpaar: "2004_2005", namen: " Maria II & Tobias I", jahr: 2005 },
    { Prinzenpaar: "2004_2005_kpp", namen: " Theresa II & David I", jahr: 2005 },
    { Prinzenpaar: "2003_2004", namen: " Simone I & Michael II", jahr: 2004 },
    { Prinzenpaar: "2003_2004_kpp", namen: " Regina I & Julian I", jahr: 2004 },
    { Prinzenpaar: "2002_2003", namen: " Sandra II & Martin I", jahr: 2003 },
    { Prinzenpaar: "2002_2003_kpp", namen: " Chistina I & Maximilian I", jahr: 2003 },
    { Prinzenpaar: "2001_2002", namen: " Maria I & Florian I", jahr: 2002 },
    { Prinzenpaar: "2000_2001", namen: " Anita II & Andreas I", jahr: 2001 },
    { Prinzenpaar: "1999_2000", namen: " Evi I & Maximilian I", jahr: 2000 },
    { Prinzenpaar: "1998_1999", namen: " Beate II & Hans I", jahr: 1999 },
    { Prinzenpaar: "1997_1998", namen: " Karin I & Lorenz I", jahr: 1998 },
    { Prinzenpaar: "1996_1997", namen: " Anita I & Roland II", jahr: 1997 },
    { Prinzenpaar: "1995_1996", namen: " Bettina I & Stefan I", jahr: 1996 },
    { Prinzenpaar: "1994_1995", namen: " Martina I & Michael I", jahr: 1995 },
    { Prinzenpaar: "1993_1994", namen: " Beate I & Manfred I", jahr: 1994 },
    { Prinzenpaar: "1992_1993", namen: " Christine I & Hubert I", jahr: 1993 },
    { Prinzenpaar: "1991_1992", namen: " Michaela I & Christian I", jahr: 1992 },
    { Prinzenpaar: "1990_1991", namen: " Sandra I & Heinz I", jahr: 1991 },
    { Prinzenpaar: "1989_1990", namen: " Andrea I & Josef I", jahr: 1990 },
    { Prinzenpaar: "1988_1989", namen: " Daniela I & Roland I", jahr: 1989 },
    { Prinzenpaar: "1987_1988", namen: " Manuela I & Thomas I", jahr: 1988 }
];


  const ppItems = pps.map(pp =>
    <li className="col-md-5 verticalDivLarge">
      <img
        // src={require(`../resources/pps/${pp.Prinzenpaar}.jpg`)}
        src={"https://storage.googleapis.com/eggspatzen-data-bucket/pps/"+pp.Prinzenpaar+".jpg"}
        alt={pp.Prinzenpaar}
        />
      <p>
        {pp.namen}
        <br/>
        Saison {pp.jahr}
      </p>
    </li>
  );


  return (
    <div>
      <div className="PPs">
        <div className="pagecontent container">
          <p>PRINZENPAARE DER VEREINSGESCHICHTE</p>
        </div>
        <ul className="row justify-content-sm-center">{ppItems}</ul>
        <div className="row justify-content-sm-center" style={{ textAlign: 'center' }}>
          <img src={Logo} className="imageResize"></img>
        </div>

      </div>
    </div>
  );
}

export default Prinzenpaare;